export default __webpack_public_path__ + "maps-overivew-annotation-image-1200-8a0dff8e86170fde89e556251f0c611f.webp";